'use strict'

import {createCompareBlock} from "../../cards/compareCards";
import {setLordIcon} from "../../../lordicon";
import {BaseElement} from "../../interfaces/BaseElement";
import {isDesktop, UIRoot} from "../../../settings";

let buttonsOffset = 0;
let buttonsOffsetWeb = 0;

export function updateCompareButtonOffset (value) {
  buttonsOffset = value;
}

export function updateCompareButtonOffsetWeb (value) {
    buttonsOffsetWeb = value;
}

export function createCompareCardsButton() {
    const compareButton = new BaseElement('button')
      .addClass('compare-button', 'button')
      .event('click', createCompareBlock)
      .appendTo(UIRoot)
      .DOMElement;
    setLordIcon('compare', compareButton, {
        stroke: 90
    });
    setCompareButtonPosition(compareButton);
}

export const setCompareButtonPosition = (button) => {
  const rtl = document.querySelector('html').getAttribute('dir') === 'rtl';
  const direction = rtl ? 'left' : 'right';
  const topUnitCard = document.querySelector('.unit-card');
  const topUnitCardWidth = parseInt(getComputedStyle(topUnitCard).width);
  const buttonWidth = parseInt(getComputedStyle(button).width);
  let sideOffset = (topUnitCardWidth / 2 + 20) - (buttonWidth / 2);

  if (isDesktop) {
    const search = document.querySelector(`.search__container-main`).getBoundingClientRect().width + 80;
    button.style.right = `${search + sideOffset}px`;
    button.style.top = `calc(50% - ${buttonWidth / 2 + buttonsOffset}px)`;
  } else {
    sideOffset = (topUnitCardWidth / 2) - (buttonWidth / 2);
    direction === 'left' ?
      button.style.left = `${sideOffset + buttonsOffsetWeb}px` :
      button.style.right = `${sideOffset + buttonsOffsetWeb}px`;
  }
}
